module.exports = {
      id: "chevron-usage",
      viewBox: "0 0 12 8",
      url: __webpack_public_path__ + "img/icons.91580017.svg#chevron-usage",
      toString: function () {
        return this.url;
      }
    }